/**
 * Replace ký tự đặc biệt trong image name
 * @param src :string
 * @returns src
 */
export default (src: string): string => {
  const regex = new RegExp(/[`"'()#]/g);
  const result = src.replace(regex, '_');
  return result;
};
